export default __webpack_public_path__ + "static/media/feature-help-desk-1.0156fc09.png";